import { format, parseISO } from 'date-fns';

export const formatDate = (iso: string) => (iso ? format(parseISO(iso), 'MMM d, yyyy') : '—');

export const formatDateTime = (iso: string) => (iso ? format(parseISO(iso), 'MMM d, yyyy, h:mm a') : '—');
